import React from 'react';

export interface IComponentsContext {
  mapbox?: {
    accessToken: string;
  };
}
export const ComponentsContext = React.createContext<IComponentsContext>({});
export const ComponentsContextProvider = ComponentsContext.Provider;
